import React, { useEffect } from 'react'

import { NoData, SinglePanePage } from 'styles/shared'

import WindowLocation from 'helpers/windowLocation'

import Api from 'services/api'

const SIGNOUT_TIMEOUT = 10

const YouDontHavePermission = () => {
  useEffect(() => {
    window.setTimeout(() => {
      WindowLocation.replace(Api.Session.logout)
    }, SIGNOUT_TIMEOUT * 1000)
  }, [])

  return (
    <SinglePanePage >
      <NoData>
        <h1>You don't have permission to view this site.</h1>
        <h2>You will be signed out and redirected to the sign in screen momentarily</h2>
      </NoData>
    </SinglePanePage >
  )
}

export default YouDontHavePermission
